"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaxAttributeIncreaseEffectHandler = exports.MaxAttributeIncreaseEffectArgs = void 0;
const Attributes_1 = require("../../../metadata/Attributes");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class MaxAttributeIncreaseEffectArgs {
    constructor(attribute, amount) {
        this.attribute = attribute;
        this.amount = amount;
        this.__type = EffectType_1.EffectType.MaxAttributeIncrease;
        this.__typeName = "MaxAttributeIncrease";
        this.name = "Attribute Increase";
        this.harmful = Boolean(Attributes_1.AttributeIsHarmful[attribute]);
    }
}
exports.MaxAttributeIncreaseEffectArgs = MaxAttributeIncreaseEffectArgs;
let MaxAttributeIncreaseEffectHandler = class MaxAttributeIncreaseEffectHandler {
    apply(sequence, container, state) {
        const last = container.getMaxAttributeScore(state.targetId, state.args.attribute);
        container.setMaxAttributeScore(sequence, state.targetId, state.args.attribute, last + state.args.amount);
    }
    remove(sequence, container, state) {
        const last = container.getMaxAttributeScore(state.targetId, state.args.attribute);
        container.setMaxAttributeScore(sequence, state.targetId, state.args.attribute, last - state.args.amount);
    }
};
MaxAttributeIncreaseEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.MaxAttributeIncrease)
], MaxAttributeIncreaseEffectHandler);
exports.MaxAttributeIncreaseEffectHandler = MaxAttributeIncreaseEffectHandler;
